import gql from 'graphql-tag';

export default gql`
  mutation deleteProductSupplier($input: DeleteProductSupplierInput!) {
    deleteProductSupplier(input: $input) {
      success
    }
  }
`;
